import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MatPaginatorIntl} from '@angular/material/paginator';

import {MaterialModule} from './material/material.module';
import {CustomPaginatorIntl} from './material/custom-paginator-intl';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {CustomDateAdapter} from './custom-date-adapter';
import {CUSTOM_FORMATS} from '../app.constants';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {SafeImageModule} from '@shared-modules/safe-image/safe-image.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    NgxMaterialTimepickerModule,
    SafeImageModule,
    RouterModule
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: CustomPaginatorIntl
    },
    {provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
    {provide: MAT_DATE_FORMATS, useValue: CUSTOM_FORMATS}
  ],
  exports: [
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaterialTimepickerModule,
    SafeImageModule,
    RouterModule,
  ]
})
export class SharedModule {
}
